import React from 'react';
import { Button, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    gap: tokens.spacingHorizontalMNudge,
    marginTop: tokens.spacingVerticalXL,
  },
});

interface BatchControlsProps {
  isProcessing: boolean;
  hasJobId: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  onRefresh: () => void;
}

export default function BatchControls({ 
  isProcessing, 
  hasJobId, 
  onSubmit, 
  onCancel,
  onRefresh
}: BatchControlsProps) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Button
        appearance="primary"
        size="large"
        onClick={onSubmit}
        disabled={isProcessing}
      >
        {isProcessing ? 'Processing...' : 'Submit Batch Job'}
      </Button>

      {isProcessing && hasJobId && (
        <Button
          appearance="secondary"
          size="large"
          onClick={onCancel}
          style={{ color: tokens.colorPaletteRedForeground1 }}
        >
          Cancel Job
        </Button>
      )}

      <Button
        appearance="secondary"
        size="large"
        onClick={onRefresh}
        title="Clear all data and start fresh"
      >
        Refresh
      </Button>
    </div>
  );
}